// src/pages/RegistrationFuiteDonnees/components/RegistrationSteps.tsx
import React from 'react';
import './RegistrationSteps.scss';

interface RegistrationStepsProps {
  steps: Array<{
    number: number;
    label: string;
    completed: boolean;
    active?: boolean;
  }>;
}

const RegistrationSteps: React.FC<RegistrationStepsProps> = ({ steps }) => {
  return (
    <div className="registration-steps">
      <div className="registration-steps__track">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className={`registration-steps__step ${
              step.completed ? 'completed' :
                step.active ? 'active' : ''
            }`}>
              <div className="registration-steps__circle">
                {step.completed ? '' : step.number}
              </div>
              <span className="registration-steps__label">{step.label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default RegistrationSteps;